module.exports = __webpack_public_path__ + "static/media/alien.b11fa22.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/alien.mp3
// module id = JXeb
// module chunks = 74